// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ReportIssueModal_buttonContainer__X2n3x","footer":"ReportIssueModal_footer__isgGW"};